import {DefaultFieldWindow} from "./DefaultFieldWindow";
import {Form as FormEntity} from "../Form";
import {
	ArrayField,
	arrayfield,
	btn,
	containerfield,
	fieldset,
	Fieldset,
	tbar,
	TextField,
	textfield
} from "@intermesh/goui";

import {t} from "../Translate";

export class SelectFieldWindow extends DefaultFieldWindow {
	protected selectOptions: ArrayField<string>;
	constructor(formEntity:FormEntity, type:string) {
		super(formEntity, type);


		this.cards.items.add(
			fieldset({title: t("Options")},
			containerfield({name: "options"},
				this.selectOptions = arrayfield<string>({
					name: "options",
					label: t("Options"),
					buildField: value => {
						return textfield({
							name: "value",
							label: t("Option"),
							buttons: [
								btn({
									icon: "delete",
									handler: (btn) => {
										btn.findAncestorByType(TextField)!.remove();
									}
								})
							]
						})
					}
				}),

				tbar({},
					'->',
					btn({
						icon: "add",
						cls: "outlined",
						text: t("Add"),
						handler: (btn) => {

							const field = this.selectOptions.addValue("");
							btn.el.scrollIntoView();
							field.focus();
						}
					})
				)
			)),
		)
	}
}